import { render, staticRenderFns } from "./outPriceTab.vue?vue&type=template&id=72228750&"
import script from "./outPriceTab.vue?vue&type=script&lang=js&"
export * from "./outPriceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports